/**
 * データ構造
 * @return {
 *  service_name: string
 * }
 */
const state = {
  service_name: ''
};

const actions = {
  initData({ dispatch }, eop_contents = {}) {
    dispatch('setServiceName', eop_contents.service_name);
  },
  setServiceName({ commit }, service_name) {
    commit('SET_SERVICE_NAME', service_name);
  }
};

const getters = {
  isM3comapp(state) {
    return state.service_name === 'pcareer-m3comapp';
  },
  isPcareerapp(state) {
    return state.service_name === 'pharmacist-career-app';
  }
};

const mutations = {
  SET_SERVICE_NAME(state, value) {
    state.service_name = value;
  }
};

export default {
  namespaced: true,
  state: () => state,
  getters,
  actions,
  mutations
};
